import { render, staticRenderFns } from "./CatalogSearchEditorDialog.vue?vue&type=template&id=2d925d87&scoped=true"
import script from "./CatalogSearchEditorDialog.vue?vue&type=script&lang=js"
export * from "./CatalogSearchEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d925d87",
  null
  
)

export default component.exports